export default __webpack_public_path__ + "static/media/eee.282a523e.jpg";